/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who1_DescInputs */

const en_dr_who1_desc = /** @type {(inputs: Dr_Who1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A co-founder, two teammates, one link. Async brainwriting over two days beats a video call neither of you can schedule.`)
};

const id_dr_who1_desc = /** @type {(inputs: Dr_Who1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-founder, dua rekan tim, satu tautan. Brainwriting asinkron dua hari lebih efektif daripada video call yang susah dijadwalkan bersama.`)
};

/**
* | output |
* | --- |
* | "A co-founder, two teammates, one link. Async brainwriting over two days beats a video call neither of you can schedule." |
*
* @param {Dr_Who1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who1_desc = /** @type {((inputs?: Dr_Who1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who1_desc(inputs)
	return en_dr_who1_desc(inputs)
});